/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_No_Event_GroupsInputs */



/**
* | output |
* | --- |
* | "No eligible Event Groups available." |
*
* @param {Offline_Sync_No_Event_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_no_event_groups = /** @type {((inputs?: Offline_Sync_No_Event_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_No_Event_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun groupe d'événements éligible disponible.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine geeigneten Ereignisgruppen verfügbar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun gruppo eventi idoneo disponibile.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет подходящих групп событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay grupos de eventos elegibles disponibles.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("没有可用的事件组。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("対象となるイベントグループがありません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई उपयुक्त इवेंट समूह उपलब्ध नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não existem grupos de eventos elegíveis.")
	return /** @type {LocalizedString} */ ("No eligible Event Groups available.")
});